import React, { useState, useEffect } from 'react';

function Toggle({ label, description, enabled, onChange }) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-gray-700 last:border-0">
      <div>
        <div className="text-sm font-medium text-gray-900 dark:text-gray-100">{label}</div>
        <div className="text-xs text-gray-500 dark:text-gray-400">{description}</div>
      </div>
      <button
        onClick={() => onChange(!enabled)}
        className={`relative w-11 h-6 rounded-full transition-colors ${
          enabled ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'
        }`}
      >
        <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${
          enabled ? 'translate-x-5' : 'translate-x-0'
        }`} />
      </button>
    </div>
  );
}

export default function NotificationSettings({ config, onUpdateConfig, permissionState }) {
  const [localConfig, setLocalConfig] = useState(config);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLocalConfig(config);
  }, [config]);

  const handleToggle = async (field, value) => {
    const newConfig = { ...localConfig, [field]: value };
    setLocalConfig(newConfig);
    setSaving(true);
    try {
      await onUpdateConfig(newConfig);
    } catch (err) {
      setLocalConfig(localConfig);
    }
    setSaving(false);
  };

  if (!localConfig) return null;

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-4">
        Mis Notificaciones
      </h3>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
        Configura como recibir alertas de seguimientos programados.
      </p>

      <Toggle
        label="Notificaciones del navegador"
        description={
          permissionState === 'granted'
            ? 'Popups del sistema operativo'
            : permissionState === 'denied'
            ? 'Bloqueado - habilitar en configuracion del navegador'
            : 'Requiere permiso del navegador'
        }
        enabled={localConfig.push_enabled && permissionState === 'granted'}
        onChange={(v) => handleToggle('push_enabled', v)}
      />
      <Toggle
        label="Alertas en el CRM"
        description="Banners en la app"
        enabled={localConfig.toast_enabled}
        onChange={(v) => handleToggle('toast_enabled', v)}
      />
      <Toggle
        label="Sonido"
        description="Alerta sonora al recibir notificacion"
        enabled={localConfig.sound_enabled}
        onChange={(v) => handleToggle('sound_enabled', v)}
      />
      <Toggle
        label="WhatsApp"
        description="Mensaje con botones a tu numero"
        enabled={localConfig.whatsapp_enabled}
        onChange={(v) => handleToggle('whatsapp_enabled', v)}
      />

      {saving && (
        <div className="text-xs text-gray-400 mt-2">Guardando...</div>
      )}
    </div>
  );
}
